import Cookies from "js-cookie";

const TokenKey = "token";
const NameKey = "userInfo";
// 获取token
export function getToken() {
  return Cookies.get(TokenKey);
}
// 设置token
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
// 移除token
export function removeToken() {
  return Cookies.remove(TokenKey);
}
/**
 * 从 Cookie 中获取用户信息
 * 如果 Cookie 中存在用户信息，则返回解析后的用户对象，否则返回一个空对象
 * @returns {Object} - 用户对象
 */
export function getUser() {
  try {
    const user = Cookies.get(NameKey);
    return JSON.parse(user);
  } catch (error) {
    return {}
  }
}
// 设置用户信息
export function setUser(name) {
  return Cookies.set(NameKey, name);
}
// 移除用户信息
export function removeUser() {
  return Cookies.remove(NameKey);
}

